import React from "react";
import { Row, Col, Button } from "reactstrap";
import { Offcanvas, OffcanvasBody } from "reactstrap";
import ReviewForm from './ReviewForm';
import ReviewList from './ReviewList';

const VesselDetailsOffcanvas = ({ isOpen, toggle, selectedVessel }) => {
  if (!selectedVessel) return null;
  console.log('selected Vessel', selectedVessel);

  return (
    <Offcanvas
      isOpen={isOpen}
      direction="end"
      className="vessel-offcanvas"
    >
      <OffcanvasBody>
        {/* Main Content */}
        <div className="row canvess-content">
          <div className="col-md-6 position-relative first-column col-padding-30">
            {/* Custom Rounded Close Button */}
            <Button
              className="vessel-close-btn"
              onClick={toggle}
              aria-label="Close"
            >
              &times;
            </Button>

            <div className="vessel-section">
              {/* Vessel Name */}

              {/* Vessel Image Placeholder */}
              <div className="vessel-image-placeholder">
                <img
                  src={selectedVessel.Vessel_Thumb}
                  style={{ width: '100%' }}
                />
              </div>

              {/* Profile Section */}
              <h6>Profile</h6>
              {[
                ['Flag', selectedVessel.Flag],
                ['IMO', selectedVessel.IMO],
                ['IMULA Number', selectedVessel.IMULA_Number],
                ['Call Sign', selectedVessel.Call_Sign],
                ['AIS Transponder Class', selectedVessel.AIS_transponder_Class],
                ['General Vessel Type', selectedVessel.General_vessel_Type],
                ['Detailed Vessel Type', selectedVessel.Detailed_vessel_Type],
                ['Categories', selectedVessel.Categories],
                ['Service Status', selectedVessel.Service_Status],
                ['Port of Registry', selectedVessel.Port_of_registry],
                ['Year Built', selectedVessel.Year_Built],
                ['License Category', selectedVessel.License_Category],
                ['National', selectedVessel.National],
                [
                  'Registered Date',
                  selectedVessel.Registered_Date
                    ? new Date(
                        selectedVessel.Registered_Date
                      ).toLocaleDateString()
                    : null,
                ],
              ].map(([label, value]) => (
                <div
                  className="vessel-detail"
                  key={label}
                >
                  <span className="detail-label">{label}:</span>
                  <span className="detail-value">{value || 'N/A'}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 col-padding-30">
            <div className="vessel-section">
              <h6>Vessel Characteristics</h6>
              {[
                ['Breadth', selectedVessel.Breadth],
                ['Height', selectedVessel.Height],
                ['Fuel Type', selectedVessel.Fuel_Type],
                ['Engine Type', selectedVessel.Engine_Type],
                ['Fuel Tank Capacity', selectedVessel.Fuel_Tank_Capacity],
                ['Hold Capacity', selectedVessel.Hold_Capacity],
                ['Engine Capacity', selectedVessel.Engine_Capacity],
                ['Fuel Consumption', selectedVessel.Fuel_Consumption],
                ['Fishing Methods', selectedVessel.Fishing_Methods],
                ['Hull Material', selectedVessel.Hull_Material],
              ].map(([label, value]) => (
                <div
                  className="vessel-detail"
                  key={label}
                >
                  <span className="detail-label">{label}:</span>
                  <span className="detail-value">{value || 'N/A'}</span>
                </div>
              ))}
            </div>
            <div className="vessel-section">
              <h6>Owner/Ship</h6>
              <div className="vessel-detail">
                <span className="detail-label">Owner Name:</span>
                <span className="detail-value">
                  {selectedVessel.Owner_Name || 'N/A'}
                </span>
              </div>
              <div className="vessel-detail">
                <span className="detail-label">Owner Address:</span>
                <span className="detail-value">
                  {selectedVessel.Owner_Address || 'N/A'}
                </span>
              </div>
            </div>
            <div className="vessel-section">
              <h6>Compliance and Certification</h6>
              <div className="vessel-detail">
                <span className="detail-label">HACCP Certification:</span>
                <span className="detail-value">Yes</span>
              </div>
            </div>
            <div className="vessel-section">
              <h6>Review</h6>
              <ReviewList
                reviewType={'Vessel'}
                productId={selectedVessel.IMULA_Number}
              />
            </div>
            <div className="vessel-section">
              <h6>Add a Review</h6>
              <ReviewForm
                userId={'rtrt5456'}
                reviewType={'Vessel'}
                productId={selectedVessel.IMULA_Number}
              />
            </div>
          </div>
        </div>

        {/* Vessel Characteristics Section */}

        {/* Owner/Ship Section */}

        {/* Compliance and Certification Section */}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default VesselDetailsOffcanvas;
